import { useState } from "react";
import { Button, TextArea } from "../../components/common";

interface CommentFormProps {
  onSubmit: (content: string) => Promise<void>;
  placeholder?: string;
  buttonText?: string;
  className?: string;
}

export function CommentForm({
  onSubmit,
  placeholder = "Write a comment...",
  buttonText = "Post Comment",
  className = "",
}: CommentFormProps) {
  const [content, setContent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim()) return;

    setIsSubmitting(true);
    try {
      await onSubmit(content);
      setContent("");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={className}>
      <div className="rounded-lg border border-neutral-200 focus-within:border-primary/50 dark:border-neutral-700 dark:focus-within:border-primary/40 transition-colors">
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder={placeholder}
          rows={3}
          className="block w-full resize-none rounded-t-lg border-0 bg-transparent px-3.5 py-3 text-sm text-neutral-900 placeholder:text-neutral-400 focus:outline-none focus:ring-0 dark:text-white dark:placeholder:text-neutral-500"
        />
        <div className="flex justify-end rounded-b-lg bg-neutral-50/80 px-3 py-2 dark:bg-neutral-900/30">
          <Button
            type="submit"
            size="sm"
            disabled={isSubmitting || !content.trim()}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </form>
  );
}
